import React from 'react'
import Img from 'gatsby-image'

export default function ArticleImage ( props ) {

	const { image, title } = props.input
	const fluid = image?.imageFile?.childImageSharp?.fluid

	return (
		<section className="article-image">
			<div className="article-image__wrapper wrapper">
				{ fluid && <Img className="article-image__image" fluid={ fluid } /> }
				{ title && <span className="article-image__title">{ title }</span> }
			</div>
		</section>
	)
}
